import React from 'react'
import { Button } from '@surecompanies/core_components'
import { DownloadOutlined, FileExcelOutlined } from '@ant-design/icons'
import { sureco } from '../shared/finance.styles'
import {
  UploadArea,
  UploadDropHint,
  UploadDropTitle,
  UploadSelectLayout,
  UploadSelectLinks,
} from './ClientBillingProfileManagement.styles'
import { downloadTemplate } from './bulkUpload.excel'

interface BulkUploadSelectStepProps {
  fileInputRef: React.RefObject<HTMLInputElement>
  isExporting: boolean
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void
  onDownloadCurrentValues: () => void
}

/** Picks the workbook to upload, with both starting points to download. */
const BulkUploadSelectStep = ({
  fileInputRef,
  isExporting,
  onFileSelect,
  onDownloadCurrentValues,
}: BulkUploadSelectStepProps) => (
  <UploadSelectLayout>
    <input
      ref={fileInputRef}
      type="file"
      accept=".xlsx"
      onChange={onFileSelect}
      style={{ display: 'none' }}
    />
    <UploadArea
      role="button"
      tabIndex={0}
      aria-label="Select an Excel file to upload"
      onClick={() => fileInputRef.current?.click()}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        event.preventDefault()
        fileInputRef.current?.click()
      }}
    >
      <FileExcelOutlined
        style={{ fontSize: 40, color: sureco.successText, marginBottom: 12 }}
      />
      <UploadDropTitle>Click to select an Excel file</UploadDropTitle>
      <UploadDropHint>
        .xlsx only. Columns: Client Name, To Emails, Payment Type, Due Day
      </UploadDropHint>
      <UploadDropHint>
        To Emails, Payment Type, and Due Day are optional. Blank cells keep each
        profile&apos;s current value.
      </UploadDropHint>
    </UploadArea>
    <UploadSelectLinks>
      <Button
        type="link"
        icon={<DownloadOutlined />}
        onClick={onDownloadCurrentValues}
        loading={isExporting}
      >
        Download current values (.xlsx)
      </Button>
      <Button
        type="link"
        icon={<DownloadOutlined />}
        onClick={downloadTemplate}
      >
        Download example template (.xlsx)
      </Button>
    </UploadSelectLinks>
  </UploadSelectLayout>
)

export { BulkUploadSelectStep }
